import Moment from "moment"
import { Documents } from "../../components/admin/projects/ministrations/documents"

export const getDefaultRowCel = (sortedMinistrationsPlan, status) => {
  const periodColumns = {}

  sortedMinistrationsPlan.forEach(ministrationPlan => {
    const { renderer, fieldName } = MINISTRATION_ROW_LABELS[status]
    const value = ministrationPlan[fieldName]
    periodColumns[`period${ministrationPlan.orderIndex}`] = renderer(value)
  })
  return { status, ...periodColumns }
}

const MINISTRATION_ROW_LABELS = {
  "Periodo": {
    fieldName: "periodNumber",
    renderer: periodNumber => periodNumber
  },
  "Fecha de orden de pago": {
    fieldName: "ministrationDueDate",
    renderer: ministrationDueDate => Moment(ministrationDueDate).format("DD/MMMM/YYYY")
  },
  "Documentos": {
    fieldName: "ministration",
    // eslint-disable-next-line react/display-name
    renderer: ministration => {
      const ministrationDocuments = ministration?.ministrationDocuments || []
      const ministrationPaymentDocuments = ministration?.ministrationPaymentDocuments || []
      return ministrationDocuments.length > 0 || ministrationPaymentDocuments.length > 0
        ? <Documents documents={ministrationDocuments} paymentDocuments={ministrationPaymentDocuments} />
        : "No hay documentos adjuntos"
    }
  }
}

